// ViewOnDesktopCard
//
// Mobile-PWA handoff to the desktop-first web surfaces (tournyflex.com).
// Heavy management — building large events, league config, the export portal —
// is painful on a phone, so we surface a deep-link to the equivalent web route.
// Pure mobile-side UI; the web app handles the destination.

const WEB_ORIGIN = 'https://tournyflex.com'

export default function ViewOnDesktopCard({ title, description, path = '/dashboard', cta = 'Open on desktop' }) {
  const href = WEB_ORIGIN + path

  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <div style={{ fontSize: '1.4rem', lineHeight: 1, flexShrink: 0 }}>🖥️</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ fontWeight: 600, marginBottom: 4 }}>{title}</p>
          {description && (
            <p className="text-muted text-sm" style={{ marginBottom: 10 }}>{description}</p>
          )}
          <a
            className="btn btn-ghost btn-sm"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'inline-block', textDecoration: 'none' }}
          >
            {cta} ↗
          </a>
        </div>
      </div>
    </div>
  )
}
